export default __webpack_public_path__ + "static/media/spin_white.816a67f1.svg";